"use server";

import { z } from "zod";
import { actionRedirect as redirect } from "@/lib/action-redirect";
import {
  clearDemoSession,
  currentIdentity,
  requireIdentity,
  setDemoSession,
} from "@/lib/auth";
import { clearCartId } from "@/lib/cart-cookie";
import {
  createEventFor,
  resolveDemoPayment,
  startCheckout,
} from "@/lib/domain";

export async function loginDemo(formData: FormData) {
  const identityId = z
    .enum(["platform-admin", "user-1", "user-2", "user-3"])
    .parse(formData.get("identityId"));
  const previous = await currentIdentity();
  if (previous && previous.id !== identityId) await clearCartId();
  await setDemoSession(identityId);
  const next = z
    .string()
    .max(200)
    .catch("/dashboard")
    .parse(formData.get("next"));
  redirect(
    next.startsWith("/") && !next.startsWith("//") ? next : "/dashboard",
  );
}

export async function logoutDemo() {
  await clearCartId();
  await clearDemoSession();
  redirect("/login");
}

export async function createEventAction(formData: FormData) {
  const identity = await requireIdentity();
  const title = z.string().min(3).max(100).parse(formData.get("title"));
  createEventFor(identity.id, title);
  redirect("/mis-eventos?created=1");
}

export async function startCheckoutAction(formData: FormData) {
  const identity = await requireIdentity();
  const functionId = z
    .string()
    .uuid()
    .or(z.string().startsWith("function-"))
    .parse(formData.get("functionId"));
  const quantity = z.coerce
    .number()
    .int()
    .min(1)
    .max(20)
    .parse(formData.get("quantity"));
  const attempt = startCheckout(identity.id, { functionId, quantity });
  redirect(`/pago-demo/${attempt.id}`);
}

export async function resolvePaymentAction(formData: FormData) {
  const identity = await requireIdentity();
  const attemptId = z.string().uuid().parse(formData.get("attemptId"));
  const result = z
    .enum(["approved", "cancelled"])
    .parse(formData.get("result"));
  const outcome = resolveDemoPayment(identity.id, attemptId, result);
  if (outcome.orderId)
    redirect(
      `/mis-entradas?order=${outcome.orderId}&result=${outcome.outcome}`,
    );
  redirect(`/dashboard?payment=${outcome.outcome}`);
}

export async function currentDemoIdentityId() {
  return (await currentIdentity())?.id ?? null;
}
